import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';

export interface FechamentoFinanceiroDetalhe {
    idFechamentoFinanceiro: number;
    dataFechamento: string;
}

export class GetFechamentoFinanceiroResponse extends ReturnStruct {
    fechamentoFinanceiro: FechamentoFinanceiroDetalhe | null = null;
}

@Injectable({
    providedIn: 'root',
})
export class FechamentoFinanceiroService extends CommonService {
    private readonly apiUrl = `${environment.urlApiFinancas}fechamentofinanceiro/`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<GetFechamentoFinanceiroResponse> {
        return this.httpClient
            .get<GetFechamentoFinanceiroResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public save(dataFechamento: string): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, { dataFechamento }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(): Observable<ReturnStruct> {
        return this.httpClient
            .delete<ReturnStruct>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
